import { RouteSlotInput } from '@amazeelabs/react-framework-bridge/index';
import { ContentRoute } from '@caritas/ui';
import { WindowLocation } from '@reach/router';

export type StatusMessagesType = {
  status?: Array<string>;
  error?: Array<string>;
};

export const getMessagesFromLocation = (
  location: WindowLocation<
    WindowLocation['state'] & { messages?: Array<string> }
  >,
): StatusMessagesType => {
  if (location.state && location.state.messages && location.state.messages[0]) {
    try {
      return JSON.parse(location.state.messages[0]);
    } catch (e) {
      return {};
    }
  }
  return {};
};

export const mapStatusMessages = (
  messages: StatusMessagesType,
): RouteSlotInput<typeof ContentRoute, 'body', 'statusMessages'> => {
  return {
    key: 'statusMessages',
    input: () => [
      {
        status: messages.status || [],
        error: messages.error || [],
      },
      200,
    ],
  };
};
